import { navigate as _navigate } from 'svelte-routing';
export function navigate(relativeUrl) {
    if (process.env.SHOW_BROWSER_LOG) {
        console.log('navigate: ' + relativeUrl);
    }
    setTimeout(() => {
        _navigate(relativeUrl, { replace: true });
    }, 1);
}
